export default "/2.40422531497390047311949abc228ca9.png";